import { isIOS, isAndroid } from 'react-device-detect';

import { Platform } from '../constants/enums';
import { getQueryParam } from './get-query-param';

export function getPlatform() {
  const queryParamsPlatform = getQueryParam('platform');
  return queryParamsPlatform || getDevicePlatform();
}

function getDevicePlatform() {
  if (isIOS) {
    return Platform.IOS;
  }
  if (isAndroid) {
    return Platform.ANDROID;
  }
  return Platform.WEB;
}
